import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function quickSyncSheets() {
  const res = await axios.post(`${API_BASE}/appointments/quick-sync`, {}, { headers: authHeader() });
  return res.data;
}
export async function syncSheets() {
  const res = await axios.post(`${API_BASE}/appointments/sync-sheets`, {}, { headers: authHeader() });
  return res.data;
}

export async function resyncAll() {
  const res = await axios.post(`${API_BASE}/appointments/resync-all`, {}, { headers: authHeader() });
  return res.data;
}

export async function getAppointments(filters = {}) {
  const res = await axios.get(`${API_BASE}/appointments/`, { headers: authHeader(), params: filters });
  return res.data;
}

export async function updateAppointment(appointmentId, data) {
  const res = await axios.put(`${API_BASE}/appointments/${appointmentId}`, data, { headers: authHeader() });
  return res.data;
}

// Set customer_status and/or operational_status (query params) via the
// customer router. Used by the admin appointments view's action buttons.
export async function updateAppointmentStatus(appointmentId, { operational_status, customer_status } = {}) {
  const params = {};
  if (operational_status) params.operational_status = operational_status;
  if (customer_status) params.customer_status = customer_status;
  const res = await axios.put(
    `${API_BASE}/customers/appointments/${appointmentId}/status`,
    null, { headers: authHeader(), params });
  return res.data;
}

// Creates a copy of an appointment: writes a row to the appointments sheet and
// imports it. Returns { appointment_id, zcp_appointment_uid }.
export async function duplicateAppointment(appointmentId, data) {
  const res = await axios.post(`${API_BASE}/appointments/${appointmentId}/duplicate`, data, { headers: authHeader() });
  return res.data;
}

// What we already know about a phone number: { found, name, addresses[], kids[] }.
export async function getCustomerHistory(phone) {
  const res = await axios.get(`${API_BASE}/appointments/customer-history`, { headers: authHeader(), params: { phone } });
  return res.data;
}

// A shop-at-home booking typed in by staff, created through the Skipzy app.
// Returns { zcp_appointment_uid, appointment_id, extras_saved }.
export async function createNewBooking(data) {
  const res = await axios.post(`${API_BASE}/appointments/new-booking`, data, { headers: authHeader() });
  return res.data;
}

export async function getAppointmentChangeLog(appointmentId) {
  const res = await axios.get(`${API_BASE}/appointments/${appointmentId}/change-log`, { headers: authHeader() });
  return res.data;
}

export async function getErrors() {
  const res = await axios.get(`${API_BASE}/appointments/errors`, { headers: authHeader(), params: { resolved: false } });
  return res.data;
}

export async function retryAllErrors() {
  const res = await axios.post(`${API_BASE}/appointments/errors/retry-all`, {}, { headers: authHeader() });
  return res.data;
}

export async function correctError(errorId, data) {
  const res = await axios.put(`${API_BASE}/appointments/errors/${errorId}/correct`, data, { headers: authHeader() });
  return res.data;
}
